import { api } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import UserApiService from 'src/services/user/userApiService';
import { DeliveryCache } from 'src/constants';
export default class ShipmentApiService extends AbstractApiService {
  public constructor() {
    super({});
  }
  async getReceiveDeliveryEndpoint(queryParams: any) {
    const userService = new UserApiService();
    const receiveDeliverySetting = await userService.getCachedPreference(
      DeliveryCache.get_receive_delivery_cache,
    );
    if (
      receiveDeliverySetting &&
      receiveDeliverySetting[DeliveryCache.get_receive_delivery_cache] &&
      receiveDeliverySetting[DeliveryCache.get_receive_delivery_cache].enabled
    ) {
      return this.getReceiveDeliveryListCache({
        ...queryParams,
        ttl: receiveDeliverySetting[DeliveryCache.get_receive_delivery_cache]
          .ttl,
      });
    }
    return this.getReceiveDeliveryList(queryParams, {});
  }

  getReceiveDeliveryListCache(queryParams: any): Promise<any> {
    const querystring = this.encodeQueryData(queryParams);
    return super.get(api.gwt_receive_delivery_cache + '?' + querystring);
  }
  getReceiveDeliveryList(queryParams: any, filterByFields: any): Promise<any> {
    const querystring = this.encodeQueryData(queryParams);
    return super.get(
      api.get_receive_delivery + '?' + querystring,
      filterByFields,
    );
  }
  getReceiveDeliveryListByPO(queryParams: any): Promise<any> {
    const querystring = this.encodeQueryData(queryParams);
    return super.get(api.get_receive_delivery_lines + '?' + querystring, {});
  }
}
